module.exports = __webpack_public_path__ + "img/background_principal_mov-1220.4196dff9.webp";